import { getPledgeRowAmountToPay } from './pay-pledge-map';
import { shouldSkipAmountToPayRowForStatement } from './pledge-pay-amount';
import { pledgeRowCoversSurcharge } from './pledge-pay-surcharge';

export function collectPledgePaymentRows($root) {
    const pledges = [];
    const $rows = $root.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr').length
        ? $root.find('#set_pledge_payment_table .mgr-pledge-gateway-payment-table tbody tr')
        : $root.find('#set_pledge_payment_table table:first tbody tr');
    if (!$rows.length) {
        throw new Error('collectPledgePaymentRows: no payment rows found');
    }
    $rows.each(function (i) {
        const $row = $(this);
        if (shouldSkipAmountToPayRowForStatement($row, $root)) {
            return;
        }
        const pledgeId = $row.attr('data-pledge-id');
        if (pledgeId === undefined || pledgeId === null || pledgeId === '') {
            throw new Error('collectPledgePaymentRows: row missing data-pledge-id');
        }
        const amount = getPledgeRowAmountToPay($row);
        const rawGatewayId = $row.attr('data-gateway-id');
        const gatewayId = rawGatewayId === undefined || rawGatewayId === null || rawGatewayId === ''
            ? null
            : parseInt(rawGatewayId, 10);
        if (Number.isFinite(amount) && amount > 0 && (!Number.isFinite(gatewayId) || gatewayId <= 0)) {
            throw new Error(`collectPledgePaymentRows: pledge ${pledgeId} missing valid data-gateway-id`);
        }
        pledges.push({
            id: pledgeId,
            amount,
            gateway_id: gatewayId,
            cover_surcharge: pledgeRowCoversSurcharge($row, $root),
            order: i + 1,
        });
    });
    return pledges;
}
